import React, { useState, useEffect } from 'react';

const e = React.createElement;
const baseUrl = process.env.REACT_APP_API_BASE_URL;

function Admin() {
  // 1. Set up state for messages, loading status, and errors
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // 2. Fetch the data when the component loads
  useEffect(() => {
    async function fetchMessages() {
      try {
        // Grab the token we saved during login
        const token = localStorage.getItem('userToken');
        console.log(token);
        // Make the API call
        const response = await fetch(`${baseUrl}/messages/getAll`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            // This is how you prove to the server that you are logged in!
            'Authorization': `Bearer ${token}` 
          }
        });

        // Check if the server rejected the request (e.g., token expired)
        if (!response.ok) {
          throw new Error(`Server Error: ${response.status}`);
        }

        // Parse the JSON data
        const data = await response.json();
        
        // Save the data to our state
        setMessages(data.data);
        console.log("WHAT DID THE API SEND?", data);
      } catch (err) {
        console.error("Failed to fetch messages:", err);
        setError("Could not load messages. Please try again.");
      } finally {
        // Whether it succeeded or failed, we are done loading
        setIsLoading(false);
      }
    }

    fetchMessages();
  }, []); // The empty array [] means "only run this once when the page loads"

  // 3. Handle different screen states (Loading, Error, or Success)
  
  if (isLoading) {
    return e('div', { className: 'page-content' }, 
      e('h1', null, 'Admin Dashboard'),
      e('p', null, 'Loading messages...')
    );
  }

  if (error) {
    return e('div', { className: 'page-content' }, 
      e('h1', null, 'Admin Dashboard'),
      e('p', { style: { color: 'red' } }, error)
    );
  }

  // 4. Render the actual messages if we have them
  return e('div', { className: 'page-content' },
    e('h1', null, 'Admin Dashboard'),
    e('div', { className: 'admin-header' },
      e('h2', null, `Inbox (${messages.length})`)
    ),
    (!Array.isArray(messages) || messages.length === 0)
      ? e('p', null, 'No new messages.') 
      : e('div', { className: 'message-list' },
          messages.map((msg) => 
            // 1. Use the API's exact '_id' for the React key
            e('div', { key: msg._id, className: 'message-card' },
              
              // 2. Map 'name' and 'contactNumber' (since there is no email)
              e('p', null, e('strong', null, 'From: '), `${msg.name} (${msg.contactNumber})`),
              
              // 3. Convert the messy 'createdAt' string into a nice readable date
              e('p', null, e('strong', null, 'Date: '), new Date(msg.createdAt).toLocaleString()),
              
              // 4. Show the actual message content
              e('p', { className: 'msg-body' }, msg.message)
            )
          )
        )
  );
}

export default Admin;